<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © wwww.caistabgabon.com.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Réalisation <i class="mdi mdi-heart text-danger"></i> de  <a href="https://wwww.caistabgabon.com/" target="_blank" class="text-reset">I.C : AMA</a>
                </div>
            </div>
        </div>
    </div>
</footer>